import { RootRoute, NestedRouteFragment, ParametrizedRouteFragment, RouteFragment } from "../../react-core/Imports";
import { Secured } from "./Components/Secured";
import { Contents } from "./Resoures/Contents";
import { TransferWizard } from "../Admin/TransferWizard/Component/TransferWizard";
import { SecuredDashboard } from "./Components/Dashboard/Components/SecuredDashboard";
import { AdminDashboard } from "../Admin/Dashboard/AdminDashboard";
import { BusinessManagement } from "./Components/BusinessManagement/BusinessManagement";
import { SearchTable } from "../Admin/ResidualCashPaymentOutWizard/Components/SearchTable";
import { Methods } from "./Common/CommonHelper";
import { NetworkSubmitted } from "../Admin/Network/Components/NetworkSubmitted";
import { NetworkInProgress } from "../Admin/Network/Components/NetworkInProgress";
import { CompanyWizardInProgress } from "../Admin/Company/CompanyWizard/Components/CompanyWizardInProgress";
import { CompanyWizardHistory } from "../Admin/Company/CompanyWizard/Components/CompanyWizardHistory";
import { NewBusinessWizard } from "./Components/Clients/NewBusinessWizard/Components/NewBusinessWizard";
import { CompanySetUp } from "../Admin/Company/CompanyWizard/Components/CompanySetUp";
import { CompanySetupWizard } from "../Admin/Company/CompanyWizard/Components/CompanySetUpWizard/CompanySetupWizard";
import { NetworkWizard } from "../Admin/Network/Components/NetworkWizard";
import { NetworkDashboard } from "../Admin/Network/Components/NetworkDashboard";
import { ViewCompany } from "../Admin/Company/CompanyWizard/Components/ViewCompany/ViewCompany";
import { ClientRecord } from "./Components/Clients/ClientRecord/ClientRecord";
import { NewQuoteWizard } from "./Components/Clients/NewQuoteWizard/Components/NewQuoteWizard";
import { AddClientWizard } from "./Components/Clients/AddClient/Components/AddClientWizard";
import { SinglePaymentTransferWizard } from "./Components/Clients/SinglePaymentTransferWizard/SinglePaymentTransferWizard";
import { BuyWizard } from "./Components/Clients/Buy/BuyWizard";
import { RegularPaymentWizard } from "./Components/Clients/RegularPaymentWizard/RegularPaymentWizard";
import { SellWizard } from "./Components/Clients/Sell/SellWizard";
import { SwitchWizard } from "./Components/Clients/Switch/SwitchWizard";
import { CancelOrderWizard } from "./Components/Clients/CancelOrder/CancelOrderWizard";
import { TopUpWithITFLSWizard } from "./Components/Clients/TopUpWithITFLSWizard/Components/TopUpWithITFLSWizard";
import { PensionBenefitsWizard } from "./Components/Clients/PensionBenefitsWizard/PensionBenefitsWizard";
import { ConvertCappedToFlexiWizard } from "./Components/Clients/ConvertCappedToFlexiWizard/ConvertCappedToFlexiWizard";
import { NewIncomePaymentOneOffWizard } from "./Components/Clients/NewOneOffIncomePaymentWizard/NewIncomePaymentOneOffWizard";
import { UpdateLifetimeAllowanceWizard } from "./Components/Clients/UpdateLifetimeAllowanceWizard/UpdateLifetimeAllowanceWizard";
import { GadReviewWizard } from "./Components/Clients/GadReviewWizard/GadReviewWizard";
import { ToolsAndLiterature } from "./Components/ToolsAndLiterature/ToolsAndLiterature";
import { ResearchInvestmentSelection } from "./Components/ToolsAndLiterature/Components/ResearchInvestmentSeletionTool";
import { BackOffice } from "./Components/BusinessManagement/BackOffice/Components/BackOffice";
import { EditIncomeWithdrawalsWizard } from "./Components/Clients/EditIncomeWithdrawalsWizard/EditIncomeWithdrawalsWizard";
import { CancelRegularCrystallisationWizard } from "./Components/Clients/CancelRegularCrystallisationWizard/CancelRegularCrystallisationWizard";
import { AddLogoWizard } from "./Components/Settings/AddLogo/Component/AddLogoWizard";
import { Settings } from "./Components/Settings/Settings";
import { SelectCustomers } from "./Components/Clients/CustomerMerge/Components/SelectCustomers";
import { CustomerMergeDetails } from "./Components/Clients/CustomerMerge/Components/CustomerMergeDetails";
import { WhatIfToolWizard } from "./Components/Clients/WhatIfTool/WhatIfToolWizard";
import { NoChangeToolWizard } from "./Components/Clients/NoChangeWizard/NoChangeToolWizard";
import { CaptialGainSettingsWizard } from "./Components/Clients/CapitalGainsSettings/CaptialGainSettingsWizard";
import { InterestedPartiesWizard } from "./Components/Clients/InterestedPartiesWizard/InterestedPartiesWizard";
import { AddTrustMembersWizard } from "./Components/Clients/ClientRecord/AddTrustMember/AddTrustMembersWizard";
import { AddBeneficiaryWizard } from "./Components/Clients/ClientRecord/AddBeneficary/AddBeneficiaryWizard";
import { ComponentClass } from "react";
import { ContextActions } from "../../react-core/Flux/ContextActions";
import { ContextType } from "../../Wrap/Constants/Enums/ContextType";
import { PortfolioDashboard } from "./Components/Clients/PortfolioDashboard/Components/PortfolioDashboard";
import { ContextStore } from "../../react-core/Flux/Variables";
import { RouteComponent } from "react-router";
import { CustomerSearch } from "./Components/Clients/ClientSearch/ClientSearch";
import { HistoricWorkflowDashboard } from "./Components/Workflow/HistoricWorkflowDashboard";
import { RemunerationStatement } from "./Components/Reports/Components/RemunerationStatement";

export class SubAccountUrls extends ParametrizedRouteFragment<{ subaccounthierarchyId: string }> {
    constructor(
        route: string,
        parameters: { subaccounthierarchyId: string },
        component: ComponentClass<any, any>,
        parent: RouteFragment,
        indexComponent?: RouteComponent | string
    ) {
        super(route, parameters, component, parent, indexComponent);

        this.onEnter((stuff) => ContextActions.setContext(stuff.subaccounthierarchyId, ContextType.SubAccount));
    }
    public productOverView = this.createPage("productoverview", PortfolioDashboard);
}

export class HeadAccountUrls extends ParametrizedRouteFragment<{ headaccounthierarchyId: string }> {
    constructor(
        route: string,
        parameters: { headaccounthierarchyId: string },
        component: ComponentClass<any, any>,
        parent: RouteFragment,
        indexComponent?: RouteComponent | string
    ) {
        super(route, parameters, component, parent, indexComponent);

        this.onEnter((stuff) => ContextActions.setContext(stuff.headaccounthierarchyId, ContextType.Account));
    }
    public clientReport = this.createPage("clientreport", PortfolioDashboard);
}

export class ContextUrls extends ParametrizedRouteFragment<{ hierarchyId: string }> {
    constructor(
        route: string,
        parameters: { hierarchyId: string },
        component: ComponentClass<any, any>,
        parent: RouteFragment,
        indexComponent?: RouteComponent | string
    ) {
        super(route, parameters, component, parent, indexComponent);

        this.onEnter((stuff) => ContextActions.setContext(stuff.hierarchyId, ContextType.Customer));
    }
    public summary = this.createPage("summary", PortfolioDashboard);
    public investments = this.createPage("investments", PortfolioDashboard);
    public insights = this.createPage("insights", PortfolioDashboard);
    public activity = this.createPage("activity", PortfolioDashboard);
    public transactions = this.createPage("transactions", PortfolioDashboard);
    public documents = this.createPage("documents", PortfolioDashboard);
    public roles = this.createPage("roles", PortfolioDashboard);
    public performance = this.createPage("performance", PortfolioDashboard);
    public esg = this.createPage("esg", PortfolioDashboard);
    public detail = this.createPage("detail", ClientRecord);
    public personalDetail = this.createPage("detail/personal-details", ClientRecord);
    public regulatoryChecks = this.createPage("detail/regulatory-checks", ClientRecord);
    public regulatory = this.createPage("detail/regulatory", ClientRecord);
    public addressDetail = this.createPage("detail/address-details", ClientRecord);
    public ContactDetail = this.createPage("detail/contact-details", ClientRecord);
    public PensionProtection = this.createPage("detail/pension-protection", ClientRecord);
    public OrganisationDetails = this.createPage("detail/organisation-details", ClientRecord);
    public TrustServicing = this.createPage("detail/trust-servicing", ClientRecord);
    public CompanyDetails = this.createPage("detail/company-details", ClientRecord);

    public productOverView = this.createCustomParamPage<{ subaccounthierarchyId: string }, SubAccountUrls>(
        "subaccount/:subaccounthierarchyId",
        null, // Layouts.ContextLayout,
        SubAccountUrls,
        "subaccount"
    );
    public clientReport = this.createCustomParamPage<{ headaccounthierarchyId: string }, HeadAccountUrls>(
        "headaccount/:headaccounthierarchyId",
        null, // Layouts.ContextLayout,
        HeadAccountUrls,
        "headaccount"
    );
}

export class DashobardUrls extends NestedRouteFragment {
    public Dashboard = this.createPage(Contents.URLMap.dashboard, SecuredDashboard);
    public Notifications = this.createPage(Contents.URLMap.dashboard + "/notifications", SecuredDashboard);
    public ConfigureNotifications = this.createPage(
        Contents.URLMap.dashboard + "/notifications/configure-notification",
        SecuredDashboard
    );
    public Admin = this.createPage(Contents.URLMap.admin, AdminDashboard);
    public BusinessManagement = this.createPage(Contents.URLMap.BusinessManagement, BusinessManagement);
    public Client = this.createPage(Contents.URLMap.customer, CustomerSearch);
    public ToolAndLiterature = this.createPage(Contents.URLMap.toolsAndLiterature, ToolsAndLiterature);
    public Settings = this.createPage(Contents.URLMap.settings, Settings);
    public HistoricWorkflowDashboard = this.createPage(Contents.URLMap.workflow, HistoricWorkflowDashboard);
    //Admin
    public AccountClosureList = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.accountClosureList}`,
        SearchTable
    );
    public CompanyWizardInprogress = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.companyWizardInProgress}`,
        CompanyWizardInProgress
    );
    public CompanyWizardHistory = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.companyWizardHistory}`,
        CompanyWizardHistory
    );
    public CompanySetup = this.createPage(`${Contents.URLMap.admin}/${Contents.URLMap.companySetup}`, CompanySetUp);
    public NetworkSubmitted = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.networkSubmitted}`,
        NetworkSubmitted
    );

    public NetworkInProgress = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.networkInProgress}`,
        NetworkInProgress
    );

    public NetworkWizardSetup = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.networkSetup}`,
        NetworkDashboard
    );

    //customer level dashboard
    public PortfolioDashboard = this.createCustomParamPage<{ hierarchyId: string }, ContextUrls>(
        "customer/:hierarchyId",
        null, // Layouts.ContextLayout,
        ContextUrls,
        "Customer"
    );

    public currentContext(): ContextUrls {
        return this.PortfolioDashboard({ hierarchyId: ContextStore.getContext().hierarchyId });
    }

    //Research IST
    public ResearchIst = this.createPage(
        `${Contents.URLMap.toolsAndLiterature}/${Contents.URLMap.researchIst}`,
        ResearchInvestmentSelection
    );

    public BackOffice = this.createPage(
        `${Contents.URLMap.BusinessManagement}/${Contents.URLMap.backOffice}`,
        BackOffice
    );

    public RemunerationStatement = this.createPage(
        `${Contents.URLMap.reports}/${Contents.URLMap.remunerationstatement}`,
        RemunerationStatement
    );

    public CustomerMergeSelectCustomers = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.customerMerge}/${Contents.URLMap.selectCustomers}`,
        SelectCustomers
    );

    public CustomerMergeDetails = this.createPage(
        `${Contents.URLMap.admin}/${Contents.URLMap.customerMerge}/${Contents.URLMap.mergeDetails}`,
        CustomerMergeDetails
    );
}

export class UrlsMap extends RootRoute {
    public main = this.createCustomPage<DashobardUrls>(
        "main",
        Secured,
        DashobardUrls,
        ContextStore.getContext().isAdminUser ? "Customer" : "Dashboard"
    );
    public TransferWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.transferWizard}`,
        TransferWizard
    );

    public CancelOrder = this.createPage(
        `main/${Contents.URLMap.account}/${Contents.URLMap.cancelOrder}/${Contents.URLMap.cancel}`,
        CancelOrderWizard
    );
    public CancelOrderReview = this.createPage(
        `main/${Contents.URLMap.account}/${Contents.URLMap.cancelOrder}/${Contents.URLMap.review}`,
        CancelOrderWizard
    );
    public TransferWizardStepOne = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.transferWizard}/${Contents.URLMap.transferWizardStepOne}`,
        TransferWizard
    );
    public TransferWizardStepTwo = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.transferWizard}/${Contents.URLMap.transferWizardStepTwo}`,
        TransferWizard
    );
    public CompanySetupWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companySetupWizard}`,
        CompanySetupWizard
    );
    public CompanyViewFirmDetail = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companyView}/${Contents.URLMap.firmdetail}`,
        ViewCompany
    );
    public CompanyViewCommission = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companyView}/${Contents.URLMap.remunerationAndValuation}`,
        ViewCompany
    );
    public FirmDetail = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companySetupWizard}/${Contents.URLMap.firmdetail}`,
        CompanySetupWizard
    );
    public RemunerationAndValuation = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companySetupWizard}/${Contents.URLMap.remunerationAndValuation}`,
        CompanySetupWizard
    );
    public ValidationAndExcution = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companySetupWizard}/${Contents.URLMap.validationAndExcute}`,
        CompanySetupWizard
    );
    public Alert = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.companySetupWizard}/${Contents.URLMap.alert}`,
        CompanySetupWizard
    );
    public ServiceProviderNetworkWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.networkSetupWizard}/${Contents.URLMap.networkServiceProvider}`,
        NetworkWizard
    );
    public NetworkDetailsWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.networkSetupWizard}/${Contents.URLMap.networkDetail}`,
        NetworkWizard
    );
    public ValuationNetworkWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.networkSetupWizard}/${Contents.URLMap.remunerationAndValuation}`,
        NetworkWizard
    );
    public ValidationNetworkWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.networkSetupWizard}/${Contents.URLMap.validationAndExcute}`,
        NetworkWizard
    );
    public ConfirmNetworkWizard = this.createPage(
        `main/${Contents.URLMap.admin}/${Contents.URLMap.networkSetupWizard}/${Contents.URLMap.confirmation}`,
        NetworkWizard
    );
    public NewQuoteWizard = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}`,
        NewQuoteWizard
    );
    public QuoteWrapperSelection = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.wrapperSelection}`,
        NewQuoteWizard
    );
    public QuotePaymentsInSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.paymentInSIPP}`,
        NewQuoteWizard
    );
    public QuotePaymentsInISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.paymentInISA}`,
        NewQuoteWizard
    );
    public QuotePaymentsInPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.paymentInPP}`,
        NewQuoteWizard
    );
    public QuoteAdviserChargesSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.adviserChargesSIPP}`,
        NewQuoteWizard
    );
    public QuoteAdviserChargesISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.adviserChargesISA}`,
        NewQuoteWizard
    );
    public QuoteWithdrawalsISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.withdrawalsISA}`,
        NewQuoteWizard
    );
    public QuoteAdviserChargesPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.adviserChargesPP}`,
        NewQuoteWizard
    );
    public QuoteInvestmentSelectionSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.investmentSelectionSIPP}`,
        NewQuoteWizard
    );
    public QuoteSIPPComplete = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.completeSIPP}`,
        NewQuoteWizard
    );
    public QuoteISAComplete = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.completeISA}`,
        NewQuoteWizard
    );
    public QuotePPComplete = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.completePP}`,
        NewQuoteWizard
    );
    public QuoteInvestmentSelectionISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.investmentSelectionISA}`,
        NewQuoteWizard
    );
    public QuoteInvestmentSelectionPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.investmentSelectionPP}`,
        NewQuoteWizard
    );
    public QuoteWithdrawalsPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.withdrawalsPP}`,
        NewQuoteWizard
    );
    public QuoteReady = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.quoteReady}`,
        NewQuoteWizard
    );
    public QuoteDrawdownDetailSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.drawdownDetailSipp}`,
        NewQuoteWizard
    );
    public QuoteIncomePaymentSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newQuoteWizard}/${Contents.URLMap.incomePaymentsSIPP}`,
        NewQuoteWizard
    );
    public NewBusinessWizard = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}`,
        NewBusinessWizard
    );
    public FullClientDetail = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.fullClientDetail}`,
        NewBusinessWizard
    );
    public WrapperSelection = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.wrapperSelection}`,
        NewBusinessWizard
    );
    public NBPaymentsInSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.paymentInSIPP}`,
        NewBusinessWizard
    );
    public NBAdviserChargesSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.adviserChargesSIPP}`,
        NewBusinessWizard
    );
    public NBInvestmentSelectionSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.investmentSelectionSIPP}`,
        NewBusinessWizard
    );
    public NBIncomePaymentsSIPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.incomePaymentsSIPP}`,
        NewBusinessWizard
    );
    public NBSIPPComplete = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.completeSIPP}`,
        NewBusinessWizard
    );
    public NBISAComplete = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.completeISA}`,
        NewBusinessWizard
    );
    public NBPPComplete = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.completePP}`,
        NewBusinessWizard
    );
    public NBPaymentsInISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.paymentInISA}`,
        NewBusinessWizard
    );
    public NBAdviserChargesISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.adviserChargesISA}`,
        NewBusinessWizard
    );
    public NBInvestmentSelectionISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.investmentSelectionISA}`,
        NewBusinessWizard
    );
    public NBWithdrawalsISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.withdrawalsISA}`,
        NewBusinessWizard
    );
    public NBPaymentsInPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.paymentInPP}`,
        NewBusinessWizard
    );
    public NBAdviserChargesPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.adviserChargesPP}`,
        NewBusinessWizard
    );
    public NBInvestmentSelectionPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.investmentSelectionPP}`,
        NewBusinessWizard
    );
    public NBWithdrawalsPP = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.withdrawalsPP}`,
        NewBusinessWizard
    );
    public PaymentsInISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.paymentInISA}`,
        NewBusinessWizard
    );
    public AdviserChargesISA = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.adviserChargesISA}`,
        NewBusinessWizard
    );
    public NBPaymentsInWrapCash = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.paymentsInWrapCash}`,
        NewBusinessWizard
    );
    public NBPaymentsInLegacyProduct = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.paymentsInLegacyProduct}`,
        NewBusinessWizard
    );
    public InvestmentSelection = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.investmentSelectionISA}`,
        NewBusinessWizard
    );
    public RegularWithdrawalsNewbusiness = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.regularWithdrawals}`,
        NewBusinessWizard
    );
    public DrawdownNewbusiness = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.drawdownDetailSipp}`,
        NewBusinessWizard
    );
    public NewBusinessDisinvestmentStrategy = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.disinvestmentStrategy}`,
        NewBusinessWizard
    );
    public NewBusinessReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.review}`,
        NewBusinessWizard
    );
    public DocumentAndDeclarations = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.documentAndDeclarations}`,
        NewBusinessWizard
    );
    public Confirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.newBusinessWizard}/${Contents.URLMap.confirmation}`,
        NewBusinessWizard
    );
    public ClientType = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.addClientWizard}/${Contents.URLMap.clientType}`,
        AddClientWizard
    );
    public ClientDetails = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.addClientWizard}/${Contents.URLMap.clientDetails}`,
        AddClientWizard
    );

    public TrustDetail = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.addClientWizard}/${Contents.URLMap.trustDetail}`,
        AddClientWizard
    );
    public TrustMember = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.addClientWizard}/${Contents.URLMap.trustMember}`,
        AddClientWizard
    );

    public CorporateDetail = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.addClientWizard}/${Contents.URLMap.corporateDetail}`,
        AddClientWizard
    );

    public CorporateMember = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.addClientWizard}/${Contents.URLMap.corporateMember}`,
        AddClientWizard
    );

    // SP/T Wizard
    public SPTPaymentsIn = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.spt}/${Contents.URLMap.paymentIn}`,
        SinglePaymentTransferWizard
    );
    public SPTAdviserCharge = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.spt}/${Contents.URLMap.adviserCharges}`,
        SinglePaymentTransferWizard
    );
    public SPTist = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.spt}/${Contents.URLMap.ist}`,
        SinglePaymentTransferWizard
    );
    public SPTreview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.spt}/${Contents.URLMap.review}`,
        SinglePaymentTransferWizard
    );
    public SPTdoc = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.spt}/${Contents.URLMap.documentAndDeclarations}`,
        SinglePaymentTransferWizard
    );
    public SPTconfirm = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.spt}/${Contents.URLMap.confirmation}`,
        SinglePaymentTransferWizard
    );

    // what if tool wizard
    public WhatIfToolChangesModel = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.wrapperSelection}`,
        WhatIfToolWizard
    );
    public WhatIfToolClientDetail = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.clientDetails}`,
        WhatIfToolWizard
    );
    public WhatIfToolPaymentsIn = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.paymentIn}`,
        WhatIfToolWizard
    );
    public WhatIfToolAdviserCharge = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.adviserCharges}`,
        WhatIfToolWizard
    );
    public WhatIfToolAdHocCharge = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.adHocAdviserCharge}`,
        WhatIfToolWizard
    );
    public WhatIfToolInvestmentSelection = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.ist}`,
        WhatIfToolWizard
    );
    public WhatIfToolOneOffWithdrawal = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.oneOffWithdrawal}`,
        WhatIfToolWizard
    );
    public WhatIfToolRegularWithdrawal = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.regularWithdrawals}`,
        WhatIfToolWizard
    );
    public WhatIfToolReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.review}`,
        WhatIfToolWizard
    );
    public WhatIfToolConfirm = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.whatIfTool}/${Contents.URLMap.confirmation}`,
        WhatIfToolWizard
    );

    //no change wizard
    public NoChangeToolReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.noChangeTool}/${Contents.URLMap.review}`,
        NoChangeToolWizard
    );
    public NoChangeToolConfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.noChangeTool}/${Contents.URLMap.confirmation}`,
        NoChangeToolWizard
    );

    //buy wizard
    public BuyOrderSetup = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.buy}/${Contents.URLMap.orderSetup}`,
        BuyWizard
    );
    public BuyInvestmentSelection = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.buy}/${Contents.URLMap.ist}`,
        BuyWizard
    );
    public BuyReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.buy}/${Contents.URLMap.review}`,
        BuyWizard
    );
    public BuyConfiramation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.buy}/${Contents.URLMap.confirmation}`,
        BuyWizard
    );

    // Regular Payment Wizard
    public RegularPaymentsIn = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.regularPayment}/${Contents.URLMap.paymentIn}`,
        RegularPaymentWizard
    );
    public RegularPaymentAdviserCharge = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.regularPayment}/${Contents.URLMap.adviserCharges}`,
        RegularPaymentWizard
    );
    public RegularPaymentIst = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.regularPayment}/${Contents.URLMap.ist}`,
        RegularPaymentWizard
    );
    public RegularPaymentReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.regularPayment}/${Contents.URLMap.review}`,
        RegularPaymentWizard
    );
    public RegularPaymentDoc = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.regularPayment}/${Contents.URLMap.documentAndDeclarations}`,
        RegularPaymentWizard
    );
    public RegularPaymentConfirm = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.regularPayment}/${Contents.URLMap.confirmation}`,
        RegularPaymentWizard
    );

    // top up with ITFLS wizard
    public TopUpWithITFLSPaymentsIn = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.paymentIn}`,
        TopUpWithITFLSWizard
    );
    public TopUpWithITFLSIST = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.ist}`,
        TopUpWithITFLSWizard
    );
    public TopUpWithITFLSDrawdown = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.drawdownDetail}`,
        TopUpWithITFLSWizard
    );
    public TopUpWithITFLSIncomePayment = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.incomePayment}`,
        TopUpWithITFLSWizard
    );
    public TopUpWithITFLSReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.review}`,
        TopUpWithITFLSWizard
    );
    public TopUpWithITFLSDocumentsAndDeclarations = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.documentAndDeclarations}`,
        TopUpWithITFLSWizard
    );
    public TopUpWithITFLSComfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.topUpWithITFLS}/${Contents.URLMap.confirmation}`,
        TopUpWithITFLSWizard
    );

    //sell wizard
    public SellOrderSetup = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.sell}/${Contents.URLMap.orderSetup}`,
        SellWizard
    );
    public SellInvestmentSelection = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.sell}/${Contents.URLMap.ist}`,
        SellWizard
    );
    public SellReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.sell}/${Contents.URLMap.review}`,
        SellWizard
    );
    public SellConfiramation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.sell}/${Contents.URLMap.confirmation}`,
        SellWizard
    );

    //switch wizard
    public SwitchOrderSetup = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.switch}/${Contents.URLMap.orderSetup}`,
        SwitchWizard
    );
    public SwitchFrom = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.switch}/${Contents.URLMap.switchFrom}`,
        SwitchWizard
    );
    public SwitchTo = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.switch}/${Contents.URLMap.switchTo}`,
        SwitchWizard
    );
    public SwitchReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.switch}/${Contents.URLMap.review}`,
        SwitchWizard
    );
    public SwitchConfiramation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.switch}/${Contents.URLMap.confirmation}`,
        SwitchWizard
    );

    // One Off Income Payment Wizard
    public IncomePaymentOneOffDetail = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.incomePaymentOneOff}/${Contents.URLMap.incomePaymentOneOffDetail}`,
        NewIncomePaymentOneOffWizard
    );
    public IncomePaymentOneOffReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.incomePaymentOneOff}/${Contents.URLMap.incomePaymentOneOffReview}`,
        NewIncomePaymentOneOffWizard
    );
    public IncomePaymentOneOffConfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.incomePaymentOneOff}/${Contents.URLMap.incomePaymentOneOffConfirmation}`,
        NewIncomePaymentOneOffWizard
    );

    // Update lifetime allowance
    public UpdateLifetimeAllowanceDetail = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.updateLifetimeAllowance}/${Contents.URLMap.updateLifetimeAllowanceDetail}`,
        UpdateLifetimeAllowanceWizard
    );
    public UpdateLifetimeAllowanceConfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.updateLifetimeAllowance}/${Contents.URLMap.confirmation}`,
        UpdateLifetimeAllowanceWizard
    );

    //pension benefits wizard
    public PensionBenefitsDetails = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.pensionBenefits}/${Contents.URLMap.pensionBenefitsDetails}`,
        PensionBenefitsWizard
    );
    public PensionBenefitsIncomePaymentDetails = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.pensionBenefits}/${Contents.URLMap.incomePayment}`,
        PensionBenefitsWizard
    );
    public PensionBenefitsReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.pensionBenefits}/${Contents.URLMap.review}`,
        PensionBenefitsWizard
    );
    public PensionBenefitsConfiramation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.pensionBenefits}/${Contents.URLMap.confirmation}`,
        PensionBenefitsWizard
    );

    //Convert capped to flexi wizard
    public ConvertToFlexiSelectArrangement = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.convertCappedToFlexiWizard}/${Contents.URLMap.selectArrangement}`,
        ConvertCappedToFlexiWizard
    );

    public ConvertToFlexiReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.convertCappedToFlexiWizard}/${Contents.URLMap.review}`,
        ConvertCappedToFlexiWizard
    );

    public ConvertToFlexiConfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.convertCappedToFlexiWizard}/${Contents.URLMap.confirmation}`,
        ConvertCappedToFlexiWizard
    );

    //gad review wizard
    public GadReviewIncomePaymentDetails = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.gadReview}/${Contents.URLMap.incomePayment}`,
        GadReviewWizard
    );
    public GadReviewReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.gadReview}/${Contents.URLMap.review}`,
        GadReviewWizard
    );
    public GadReviewConfiramation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.gadReview}/${Contents.URLMap.confirmation}`,
        GadReviewWizard
    );

    //edit income withdrawals wizard
    public EditIncomeWithdrawalsIncomePaymenDetails = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.editIncomeWithdrawals}/${Contents.URLMap.incomePayment}`,
        EditIncomeWithdrawalsWizard
    );

    public EditIncomeWithdrawalsReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.editIncomeWithdrawals}/${Contents.URLMap.review}`,
        EditIncomeWithdrawalsWizard
    );

    public EditIncomeWithdrawalsConfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.editIncomeWithdrawals}/${Contents.URLMap.confirmation}`,
        EditIncomeWithdrawalsWizard
    );

    //cancel regualr crystallisation wizard
    public CancelRegularCrystallisationReview = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.cancelRegularCrystallisation}/${Contents.URLMap.review}`,
        CancelRegularCrystallisationWizard
    );
    public CancelRegularCrystallisationConfirmation = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.cancelRegularCrystallisation}/${Contents.URLMap.confirmation}`,
        CancelRegularCrystallisationWizard
    );

    public AddLogo = this.createPage(
        `main/${Contents.URLMap.settings}/${Contents.URLMap.addLogo}/${Contents.URLMap.uploadLogo}`,
        AddLogoWizard
    );
    public AddLogoConfirmation = this.createPage(
        `main/${Contents.URLMap.settings}/${Contents.URLMap.addLogo}/${Contents.URLMap.confirmation}`,
        AddLogoWizard
    );

    //CGT
    public CapitalGainsSettings = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.cgt}/${Contents.URLMap.cgt}`,
        CaptialGainSettingsWizard
    );

    // interested parties wizard
    public InterestedParties = this.createPage(
        `main/${Contents.URLMap.client}/${Contents.URLMap.interestedPartiesWizard}/${Contents.URLMap.clientDetails}`,
        InterestedPartiesWizard
    );

    //add trust member
    public AddTrustMember = this.createPage(
        `main/${Contents.URLMap.customer}/${Contents.URLMap.trustMember}/${Contents.URLMap.trustMember}`,
        AddTrustMembersWizard
    );

    //add beneficiary
    public AddBeneficiary = this.createPage(
        `main/${Contents.URLMap.customer}/${Contents.URLMap.trustMember}/${Contents.URLMap.beneficiary}`,
        AddBeneficiaryWizard
    );
}

export class Urls {
    public static get(): UrlsMap {
        Urls.urls = Urls.urls || new UrlsMap(null, "main");
        return Urls.urls;
    }

    public static getCurrentUrl(): string {
        const url = window.location.pathname;
        const startIndex = Methods.findParam(url, "/", 5) + 1;
        const lastIndex = Methods.findParam(url, "/", 6) - 1;
        if (lastIndex < 0) {
            return url.substr(startIndex);
        }
        return url.substr(startIndex, lastIndex - startIndex + 1);
    }

    private static urls: UrlsMap;
}
